export default __webpack_public_path__ + "static/media/calendar-inactive.4f829110.svg";